import React from "react";

export function ErrorHandler({isSmall = false, titleValue}) {
    return (
        <div className={`main__subtitle error-handler ${isSmall ? 'error-handler_small' : ''}`}>{titleValue}</div>
    );
}
